import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import * as balanceText from 'Lib/balanceText.js';
import MicroModal from 'micromodal';

export namespace HeroSlider {
	let stopAllVideos = () => {
		let iframes = document.querySelectorAll('.modal__iframe');
		iframes.forEach((iframe) => {
			let originalSrc = iframe.getAttribute('src');
			iframe.setAttribute('src', originalSrc);
		});
	};
	let setupSlider = () => {
		let heroSliders = document.querySelectorAll('.js-hero-slider');
		let youtubePlayButtons = document.querySelectorAll('.js-youtube-play');
		let heroSlides = document.querySelectorAll('.js-hero-slider > .swiper-wrapper > .swiper-slide');

		if(youtubePlayButtons.length) {
			youtubePlayButtons.forEach((playButton) => {
				playButton.addEventListener('click', (e) => {
					e.preventDefault();
				})
			});
		}

		//For Each Hero Slider Loop through and setup swiper
		heroSliders.forEach((slider, index) => {
			slider.classList.add(`hero-slider--${index}`);
			const swiper = new Swiper(`.hero-slider--${index}`, {
				loop: true,
				autoplay: {
					delay: 7000,
				},

				// If we need pagination
				pagination: {
					el: `.hero-slider--${index} .swiper-pagination`,
					clickable: true
				},

				// Navigation arrows
				navigation: {
					nextEl: `.hero-slider--${index} .swiper-button-next`,
					prevEl: `.hero-slider--${index} .swiper-button-prev`,
				},


				on: {
					init: function () {
						balanceText();
					},
				}
			});
		});
	}


	export const init = () => {
		let modalItems = document.querySelectorAll('.js-youtube-play');
		if(modalItems.length) {
			MicroModal.init({
				onClose: function() {
					stopAllVideos();
				}
			});
		}
		setupSlider();

	}
}


document.addEventListener('DOMContentLoaded', HeroSlider.init);
